/**
 * Infused Lights — floating music player
 * Audio loads only after the visitor presses play (preload none, no autoplay).
 * Visible prev / play / next controls.
 */
(function () {
  'use strict';

  var ROOT_ID = 'infuse-music-player';
  var LS_VOL = 'infuseMusicVol';
  var LS_MUTE = 'infuseMusicMuted';
  var SS_IDX = 'infuseMusicIdx';
  var SS_PLAYING = 'infuseMusicPlaying';
  var SS_TIME = 'infuseMusicTime';
  var SS_ORDER = 'infuseMusicOrder';

  var root = document.getElementById(ROOT_ID);
  if (!root) return;

  var playlistUrl = root.getAttribute('data-playlist') || '';
  var wantAutoplay = root.getAttribute('data-autoplay') !== 'false';
  var audio = null;
  var tracks = [];
  var order = [];
  var pos = 0;
  var expanded = false;
  var ready = false;
  var awaitingSound = false;

  function $(sel, el) {
    return (el || root).querySelector(sel);
  }

  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i];
      a[i] = a[j];
      a[j] = t;
    }
    return a;
  }

  function currentTrack() {
    if (!order.length || !tracks.length) return null;
    return tracks[order[pos % order.length]] || null;
  }

  function ensureAudio() {
    if (audio) return audio;
    audio = document.createElement('audio');
    audio.preload = 'none';
    audio.setAttribute('playsinline', '');
    audio.setAttribute('webkit-playsinline', '');
    audio.style.display = 'none';
    document.body.appendChild(audio);

    var vol = parseFloat(localStorage.getItem(LS_VOL) || '0.7');
    if (isNaN(vol)) vol = 0.7;
    audio.volume = clamp(vol, 0, 1);
    audio.muted = localStorage.getItem(LS_MUTE) === '1';

    audio.addEventListener('ended', function () {
      next(true);
    });
    audio.addEventListener('timeupdate', function () {
      try {
        sessionStorage.setItem(SS_TIME, String(audio.currentTime || 0));
      } catch (e) {}
    });
    audio.addEventListener('play', function () {
      try {
        sessionStorage.setItem(SS_PLAYING, '1');
      } catch (e) {}
      updateUI();
    });
    audio.addEventListener('pause', function () {
      try {
        sessionStorage.setItem(SS_PLAYING, '0');
      } catch (e) {}
      updateUI();
    });
    return audio;
  }

  function savePos() {
    try {
      sessionStorage.setItem(SS_IDX, String(pos));
      sessionStorage.setItem(SS_ORDER, JSON.stringify(order));
    } catch (e) {}
  }

  function setAwaitingSound(on) {
    awaitingSound = !!on;
    root.classList.toggle('is-awaiting-sound', awaitingSound);
  }

  function unlockSoundOnce() {
    if (!awaitingSound || !audio) return;
    audio.muted = false;
    try {
      localStorage.setItem(LS_MUTE, '0');
    } catch (e) {}
    setAwaitingSound(false);
    var p = audio.play();
    if (p && p.catch) p.catch(function () {});
    updateUI();
  }

  function loadTrack(autoplay) {
    var t = currentTrack();
    if (!t || !t.src) return;
    var a = ensureAudio();
    var wasPlaying = !a.paused;
    a.src = t.src;
    try {
      a.load();
    } catch (e) {}
    savePos();
    updateUI();
    if (autoplay || wasPlaying) {
      var p = a.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  function play() {
    var a = ensureAudio();
    if (!a.src) loadTrack(true);
    else {
      var p = a.play();
      if (p && p.catch) p.catch(function () {});
    }
    updateUI();
  }

  function pause() {
    if (audio) audio.pause();
    updateUI();
  }

  function togglePlay() {
    expand();
    var a = ensureAudio();
    if (!a.src) {
      loadTrack(true);
      return;
    }
    if (a.paused) play();
    else pause();
  }

  function next(fromEnded) {
    if (!order.length) return;
    pos = (pos + 1) % order.length;
    savePos();
    loadTrack(true);
    if (!fromEnded) expand();
  }

  function prev() {
    if (!order.length) return;
    pos = (pos - 1 + order.length) % order.length;
    savePos();
    loadTrack(true);
    expand();
  }

  function setVolume(v) {
    var a = ensureAudio();
    a.volume = clamp(v, 0, 1);
    try {
      localStorage.setItem(LS_VOL, String(a.volume));
    } catch (e) {}
    updateUI();
  }

  function toggleMute() {
    var a = ensureAudio();
    a.muted = !a.muted;
    if (!a.muted) setAwaitingSound(false);
    try {
      localStorage.setItem(LS_MUTE, a.muted ? '1' : '0');
    } catch (e) {}
    updateUI();
  }

  function expand() {
    if (expanded) return;
    expanded = true;
    hideHint();
    root.classList.add('is-expanded');
    root.setAttribute('aria-expanded', 'true');
  }

  function updateUI() {
    var t = currentTrack();
    var titleEl = $('.imp-title');
    var playBtn = $('.imp-play');
    var vol = $('.imp-vol');
    var muteBtn = $('.imp-mute');
    var a = audio;

    if (titleEl) {
      titleEl.textContent = t ? t.title : 'Infused Lights';
      titleEl.setAttribute('title', t ? t.title : '');
    }
    if (playBtn) {
      var playing = a && !a.paused && !a.ended;
      playBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      playBtn.classList.toggle('is-playing', !!playing);
      playBtn.innerHTML = playing
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
    }
    if (vol && a) {
      vol.value = String(Math.round((a.volume || 0) * 100));
    }
    if (muteBtn && a) {
      muteBtn.classList.toggle('is-muted', !!a.muted);
      muteBtn.setAttribute('aria-label', a.muted ? 'Unmute' : 'Mute');
    }
    var pillLabel = $('.imp-pill-label');
    if (pillLabel) {
      if ((expanded || root.classList.contains('is-autoplaying')) && t) pillLabel.textContent = t.title;
      else pillLabel.textContent = '\uD83C\uDFB5 Play our music while you browse';
    }
  }

  function buildOrder() {
    order = shuffle(tracks.map(function (_, i) { return i; }));
    pos = 0;
    try {
      var savedOrder = JSON.parse(sessionStorage.getItem(SS_ORDER) || 'null');
      var savedIdx = parseInt(sessionStorage.getItem(SS_IDX) || '0', 10);
      if (Array.isArray(savedOrder) && savedOrder.length === tracks.length) {
        order = savedOrder;
        pos = isNaN(savedIdx) ? 0 : clamp(savedIdx, 0, order.length - 1);
      } else {
        savePos();
      }
    } catch (e) {
      savePos();
    }
  }

  function tryAutoplay() {
    if (!wantAutoplay || !tracks.length) return;
    expand();
    root.classList.add('is-autoplaying');
    var a = ensureAudio();
    var t = currentTrack();
    if (!t) return;
    a.muted = false;
    a.src = t.src;
    try { a.load(); } catch (e) {}
    updateUI();
    var p = a.play();
    if (p && p.then) {
      p.then(function () {
        setAwaitingSound(false);
        updateUI();
      }).catch(function () {
        // Browser blocked audible autoplay — play muted, unmute on first tap
        a.muted = true;
        setAwaitingSound(true);
        var p2 = a.play();
        if (p2 && p2.catch) p2.catch(function () {});
        var unlock = function () {
          unlockSoundOnce();
          document.removeEventListener('pointerdown', unlock, true);
          document.removeEventListener('keydown', unlock, true);
          document.removeEventListener('touchstart', unlock, true);
        };
        document.addEventListener('pointerdown', unlock, true);
        document.addEventListener('keydown', unlock, true);
        document.addEventListener('touchstart', unlock, true);
        updateUI();
      });
    }
  }

  function bind() {
    var pill = $('.imp-pill');
    var playBtn = $('.imp-play');
    var nextBtn = $('.imp-next');
    var prevBtn = $('.imp-prev');
    var vol = $('.imp-vol');
    var muteBtn = $('.imp-mute');

    if (pill) {
      pill.addEventListener('click', function (e) {
        if (!expanded) {
          e.preventDefault();
          expand();
          togglePlay();
        }
      });
    }
    if (playBtn) playBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      unlockSoundOnce();
      togglePlay();
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      unlockSoundOnce();
      next(false);
    });
    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      unlockSoundOnce();
      prev();
    });
    if (vol) vol.addEventListener('input', function () {
      setVolume(parseInt(vol.value, 10) / 100);
    });
    if (muteBtn) muteBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      toggleMute();
    });
  }

  function tryResume() {
    var wantPlay = false;
    try {
      wantPlay = sessionStorage.getItem(SS_PLAYING) === '1';
    } catch (e) {}
    if (!wantPlay) {
      tryAutoplay();
      return;
    }
    var a = ensureAudio();
    var t = currentTrack();
    if (!t) return;
    a.src = t.src;
    var seek = 0;
    try {
      seek = parseFloat(sessionStorage.getItem(SS_TIME) || '0') || 0;
    } catch (e) {}
    var onMeta = function () {
      a.removeEventListener('loadedmetadata', onMeta);
      try {
        if (seek > 0 && seek < (a.duration || Infinity)) a.currentTime = seek;
      } catch (e) {}
      var p = a.play();
      if (p && p.catch) p.catch(function () {
        tryAutoplay();
      });
      updateUI();
    };
    a.addEventListener('loadedmetadata', onMeta);
    try { a.load(); } catch (e) {}
    expand();
    root.classList.add('is-autoplaying');
    updateUI();
  }

  // First visit hint bubble (once per session) 2026-10-09
  var SS_HINT = 'infuseMusicHintShown';
  function hideHint() {
    var h = $('.imp-hint');
    if (h) h.classList.remove('is-visible');
  }
  function showHintOnce() {
    var h = $('.imp-hint');
    if (!h || expanded || root.classList.contains('is-autoplaying')) return;
    try {
      if (sessionStorage.getItem(SS_HINT) === '1') return;
      sessionStorage.setItem(SS_HINT, '1');
    } catch (e) {}
    setTimeout(function () {
      if (expanded) return;
      h.classList.add('is-visible');
      setTimeout(hideHint, 6000);
    }, 900);
  }

  function init(list) {
    tracks = (list || []).filter(function (t) {
      return t && t.src;
    });
    if (!tracks.length) {
      root.classList.add('is-empty');
      return;
    }
    buildOrder();
    bind();
    ready = true;
    root.classList.add('is-ready');
    updateUI();
    tryResume();
    showHintOnce();
  }

  function boot() {
    if (!playlistUrl) {
      var embedded = root.getAttribute('data-tracks');
      if (embedded) {
        try {
          init(JSON.parse(embedded));
          return;
        } catch (e) {}
      }
      return;
    }
    fetch(playlistUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(init)
      .catch(function () {
        root.classList.add('is-error');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
